<template>
  <header class="header">
    <div class="header-inner">
      <router-link to="/">
        <img src="../assets/images/KitingZone-LogoOneLineWhite.svg" class="logo"
        alt="KitingZone logo">
      </router-link>
      <nav class="nav">
        <ul class="nav-links">
          <li class="link">
           <router-link to="/">
             <div class="navigateTo">Products</div>
           </router-link>
         </li>
         <li class="link">
           <router-link to="/products/deals">
             <div class="navigateTo">Deals</div>
           </router-link>
         </li>
         <li class="link">
           <router-link to="/about">
             <div class="navigateTo">About us</div>
           </router-link>
         </li>
         <li class="link">
           <btn href="mailto:info@kitingzone.ch" class="btn-small">
             Contact
           </btn>
         </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import btn from './Btn';

export default {
  components: {
    btn,
  },
};
</script>

<style scoped>
  .header {
    width: 100%;
    background-color: #2D3142;
  }

  .header-inner{
    width: 100%;
    min-height: 74px;
    max-width: 1080px;
    box-sizing: border-box;
    padding: .5em 1em;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .header .logo {
    height: 24px;
    margin-top: 9px;
  }

  .nav-links {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: flex-end;
  }

  .link {
    list-style: none;
    padding: 0 2em;
  }

  .link:last-of-type{
    padding-right: 0;
  }

  .link a {
    color: #fff;
    text-decoration: none;
  }

  .navigateTo{
    padding: 5px;
    border: 2px solid transparent;
    transition: 0.2s;
  }
  .router-link-exact-active .navigateTo{
    border-bottom: 2px solid rgba(255, 255, 255, .42);
  }
  a:not(.router-link-exact-active) .navigateTo:hover{
    border-bottom: 2px solid rgba(255, 255, 255, .3);
  }

  .nav .button.btn-small {
    color: #FA5E42;
    margin: 0;
  }

  .nav .button.btn-small:hover {
    color: #fff;
  }

  @media screen and (max-width: 880px) {
    .link {
      padding: 0 .6em;
    }
  }

  @media screen and (max-width: 700px) {
    .header-inner {
      justify-content: center;
    }

    .link {
      padding: 0;
    }

    .nav {
      width: 100%;
    }

    .nav-links {
      justify-content: space-around;
      margin: 1em 0 0.75em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue